var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPermuta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.398,
    height: 8.223,
    viewBox: "0 0 9.398 8.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#FFFFFF;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.174)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.293,101.049,7.53,99.581a.294.294,0,0,0-.482.226v.881H6.557a1.169,1.169,0,0,1-1-.552l-1.9-3.043a2.335,2.335,0,0,0-1.992-1.1H0v1.175H1.666a1.169,1.169,0,0,1,1,.552l1.9,3.043a2.337,2.337,0,0,0,1.992,1.1h.492v.881a.294.294,0,0,0,.169.266.3.3,0,0,0,.125.028.29.29,0,0,0,.188-.068L9.293,101.5a.293.293,0,0,0,0-.451Z",
    transform: "translate(0 -95.988)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.458 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M247.714,33.548l-1.762-1.468a.294.294,0,0,0-.482.226v.881h-.492a2.335,2.335,0,0,0-1.992,1.1l-.106.17.693,1.108.41-.656a1.169,1.169,0,0,1,1-.552h.492v.881a.293.293,0,0,0,.169.266.3.3,0,0,0,.125.028.294.294,0,0,0,.188-.068L247.714,34a.293.293,0,0,0,0-.451Z",
    transform: "translate(-242.88 -32.012)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.665)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.073,286.164l-.409.656a1.17,1.17,0,0,1-1,.552H0v1.175H1.666a2.337,2.337,0,0,0,1.992-1.1l.106-.17Z",
    transform: "translate(0 -286.164)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPermuta);
export default __webpack_public_path__ + "static/media/icon-permuta.2123040f2dfcc777e0b8478822304378.svg";
export { ForwardRef as ReactComponent };